module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="form-horizontal col-md-offset-6 col-xs-offset-6 col-md-6 col-xs-6">\r\n    <h4 class="center">'+
((__t=( title ))==null?'':__t)+
'</h4>\r\n    <div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="contact-type">Contact Type</label>\r\n            <div class="col-md-9">\r\n                <select id="contact-type" data-placeholder="Contact Type" value="'+
((__t=( contact.type ))==null?'':__t)+
'">\r\n                    ';
 _.each(_.keys(contactTypes), function(key){ 
__p+='\r\n                    ';
 if (key == contact.type || key == "EMAIL") { 
__p+='\r\n                    <option value="'+
((__t=( key ))==null?'':__t)+
'" name="'+
((__t=( key ))==null?'':__t)+
'" selected> '+
((__t=( contactTypes[key] ))==null?'':__t)+
'</option>\r\n                    ';
 } else { 
__p+='\r\n                    <option value="'+
((__t=( key ))==null?'':__t)+
'" name="'+
((__t=( key ))==null?'':__t)+
'"> '+
((__t=( contactTypes[key] ))==null?'':__t)+
'</option>\r\n                    ';
 } 
__p+='\r\n                    ';
 }) 
__p+='\r\n                </select>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="data">Destination</label>\r\n            <div class="col-md-9">\r\n                <input class="form-control" type="text" id="data" placeholder="Data" required=""\r\n                       value="'+
((__t=( contact.data ))==null?'':__t)+
'">\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="extension">Extension</label>\r\n            <div class="col-md-9">\r\n                <input class="form-control" type="text" id="extension" placeholder="Extension" value="'+
((__t=( contact.extension ))==null?'':__t)+
'">\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="usage">Association</label>\r\n            <div class="col-md-9">\r\n                <select id="usage" data-placeholder="Usage">\r\n                    <option value=""></option>\r\n                    ';
 _.each(_.keys(addressUsages), function(key){ 
__p+='\r\n                    <option value="'+
((__t=( key ))==null?'':__t)+
'"  ';
 if (contact.usage==key) { 
__p+='  selected="true" ';
 } 
__p+=' >'+
((__t=( addressUsages[key] ))==null?'':__t)+
'</option>\r\n                    ';
 }) 
__p+='\r\n                </select>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="preferred">Primary?</label>\r\n            <div class="checkbox col-md-9">\r\n                <input type="checkbox" id="preferred" value="preferred" style="margin-left: 10px;" ';
 if (contact.preferred) { 
__p+=' checked ';
 } 
__p+=' >\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="priority">Preference</label>\r\n            <div class="col-md-9">\r\n                <select id="priority" data-placeholder="Contact priority" value="'+
((__t=( contact.priority ))==null?'':__t)+
'">\r\n                    ';
 _.each(_.keys(priorities), function(priority){ 
__p+='\r\n                    ';
 if (priority == contact.priority) { 
__p+='\r\n                    <option value="'+
((__t=( priority ))==null?'':__t)+
'" name="'+
((__t=( priorities[priority] ))==null?'':__t)+
'" selected> '+
((__t=( priorities[priority] ))==null?'':__t)+
'</option>\r\n                    ';
 } else { 
__p+='\r\n                    <option value="'+
((__t=( priority ))==null?'':__t)+
'" name="'+
((__t=( priorities[priority] ))==null?'':__t)+
'" > '+
((__t=( priorities[priority] ))==null?'':__t)+
'</option>\r\n                    ';
 } 
__p+='\r\n                    ';
 }) 
__p+='\r\n                </select>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="date-from">From</label>\r\n            <div class="col-md-9">\r\n                <input class="form-control" type="text" id="date-from" value="'+
((__t=( dateFrom ))==null?'':__t)+
'" onkeypress="return false;" placeholder="Date">\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="date-to">To</label>\r\n            <div class="col-md-9">\r\n                <input class="form-control" type="text" id="date-to" value="'+
((__t=( dateTo ))==null?'':__t)+
'" onkeypress="return false;" placeholder="Date">\r\n            </div>\r\n        </div>\r\n        ';
 if (addresses && addresses.length > 0) { 
__p+='\r\n        <div>\r\n            <div class="form-group">\r\n                <label class="col-md-3 control-label" for="addresses">Addresses</label>\r\n                <div class="col-md-9">\r\n                    <select id="addresses" data-placeholder="Related addresses" multiple="multiple">\r\n                        <option value=""></option>\r\n                        ';
 _.each(addresses, function(address, index){ 
__p+='\r\n                        <option value="'+
((__t=( address.uuid ))==null?'':__t)+
'" ';
 if((contact.addresses ||[]).indexOf(address.uuid) > -1){ 
__p+=' selected="true" ';
 } 
__p+=' >\r\n                        '+
((__t=( index + 1 ))==null?'':__t)+
' - '+
((__t=( address.address ))==null?'':__t)+
' '+
((__t=( address.town ))==null?'':__t)+
' '+
((__t=( address.state ))==null?'':__t)+
' '+
((__t=( address.zip ))==null?'':__t)+
'\r\n                        </option>\r\n                        ';
 }) 
__p+='\r\n                    </select>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        ';
 } 
__p+='\r\n        ';
 if (representatives && representatives.length > 0) { 
__p+='\r\n        <div>\r\n            <div class="form-group">\r\n                <label class="col-md-3 control-label" for="representatives">Representatives</label>\r\n                <div class="col-md-9">\r\n                    <select id="representatives" data-placeholder="Related representatives" multiple="multiple">\r\n                        <option value=""></option>\r\n                        ';
 _.each(representatives, function(representative, index){ 
__p+='\r\n                        <option value="'+
((__t=( representative.uuid ))==null?'':__t)+
'" ';
 if((contact.representatives ||[]).indexOf(representative.uuid) > -1){ 
__p+=' selected="true" ';
 } 
__p+=' >\r\n                        '+
((__t=( index + 1 ))==null?'':__t)+
' - '+
((__t=( representative.type ))==null?'':__t)+
' '+
((__t=( representative.name ))==null?'':__t)+
' '+
((__t=( representative.npi ))==null?'':__t)+
'\r\n                        </option>\r\n                        ';
 }) 
__p+='\r\n                    </select>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        ';
 } 
__p+='\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="comment">Comment</label>\r\n            <div class="col-md-9">\r\n                <textarea class="form-control" rows="2" id="comment">'+
((__t=( contact.comment ))==null?'':__t)+
'</textarea>\r\n            </div>\r\n        </div>\r\n        <div class="right-buttons">\r\n            <button type="button" class="btn btn-success" id="save-contact">'+
((__t=( mode ))==null?'':__t)+
'</button>\r\n            <button type="button" class="btn btn-danger" id="cancel-contact">Cancel</button>\r\n        </div>\r\n    </div>\r\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/contacts/contact-form.html
// module id = 255
// module chunks = 0